<!--대체될컴포넌트-->
<template>
  <div class="language-conatainer mb-1">
    <div class="solid">
      <template v-for="(lang, index) in languages" :key="lang.value">
        <input
          type="radio"
          :id="lang.value"
          name="language"
          :value="lang.value"
          v-model="pageLanguage"
        />
        <label
          :for="lang.value"
          class="button-lang"
          :class="{ selected: pageLanguage === lang.value }"
          >{{ lang.label }}</label
        >
        <span v-if="index !== languages.length - 1" class="split"> | </span>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';

import { useAudioStore } from '@/stores/audio';
import { useUserStore } from '@/stores/user';
const userStore = useUserStore();
const audioStore = useAudioStore();

const languages = [
  { value: 'ko', label: '한국어' },
  { value: 'en_US', label: 'English' },
  { value: 'ja', label: '日本語' },
  { value: 'zh', label: '中文' },
];

const { pageLanguage } = storeToRefs(userStore);
</script>

<style scoped>
input[type='radio'] {
  display: none;
}

/* div 높이 24px이어야 함 */
.language-conatainer {
  align-items: flex-start;
  gap: 0.5px;
  display: flex;
  position: relative;
  align-self: stretch;
  width: 100%;
  flex: 0 0 auto;
}

.solid {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  position: relative;
  flex: 1;
  flex-grow: 1;
}

label.button-lang {
  font-size: var(--font-size-psmall);
  color: var(--color-gray-300);
  white-space: nowrap;
  cursor: pointer;
  line-height: 1.5rem;
}

label.button-lang.selected {
  font-size: var(--font-size-psmall);
  font-weight: var(--font-weight-semibold);
  color: var(--color-gray-600);
  white-space: nowrap;
  cursor: pointer;
}

span.split {
  font-size: var(--font-size-psmall);
  color: var(--color-gray-300);
  white-space: nowrap;
}

.mb-1 {
  margin-bottom: 0.5rem;
}
</style>
